module.exports = __webpack_public_path__ + "static/media/logo.e2d7d934.png";